export interface IHttpError {
  code: string;
  message: string;
  description: string;
}

export interface HttpErrorProps {
  error: IHttpError;
}

export class HttpError extends Error {
  constructor(
    message: string,
    public statusCode: number,
    public info?: HttpErrorProps
  ) {
    super(message);
    this.name = 'HttpError';
  }
}
